import { lazy } from 'react'

export const IssuesRoutes = [
    {
        path: '/issues/categories',
        component: lazy(() => import('../views/categories-list')),
        exact: true,
        meta: {
            action: 'call',
            resource: "ACT_MANAGE_CATEGORY"
        }
    },
    {
        path: '/issues/categories/:categoryId',
        component: lazy(() => import('../views/category-details')),
        meta: {
            action: 'call',
            resource: "ACT_MANAGE_CATEGORY"
        }
    },
    {
        path: '/issues',
        component: lazy(() => import('../views/issues-list')),
        exact: true,
        meta: {
            action: 'call',
            resource: "ACT_VIEW_ISSUE_LIST"
        }
    },
    {
        path: '/issues/:issueId',
        component: lazy(() => import('../views/issue-details')),
        appLayout: true,
        className: 'chat-application custom-application',
        meta: {
            general: true
        }
    }
]

